import {
  fetchCourseRequestsTypes,
  resolveCourseRequestTypes,
  approveInHomeTutoringRequestTypes,
  declineInHomeTutoringRequestTypes,
} from './action_types';

import { makeQuery, makeMutation } from '../../config/client';
import {
  FETCH_COURSE_REQUESTS_QUERY,
  RESOLVE_COURSE_REQUEST_MUTATION,
  ENABLE_TUTOR_PRIVATE_LOCATION_MUTATION,
  DISABLE_TUTOR_PRIVATE_LOCATION_MUTATION,
} from './api';

export const fetchCourseRequests = () => makeQuery()(
  fetchCourseRequestsTypes,
  FETCH_COURSE_REQUESTS_QUERY
);

export const resolveCourseRequest = variables => makeMutation({ variables })(
  resolveCourseRequestTypes,
  RESOLVE_COURSE_REQUEST_MUTATION
);

export const approveInHomeTutoringRequest = variables => makeMutation({ variables })(
  approveInHomeTutoringRequestTypes,
  ENABLE_TUTOR_PRIVATE_LOCATION_MUTATION,
);

export const declineInHomeTutoringRequest = variables => makeMutation({ variables })(
  declineInHomeTutoringRequestTypes,
  DISABLE_TUTOR_PRIVATE_LOCATION_MUTATION
);



// WEBPACK FOOTER //
// ./src/modules/requests/actions.js